import { render, staticRenderFns } from "./BSInvoiceExtra.vue?vue&type=template&id=038197c4"
import script from "./BSInvoiceExtra.vue?vue&type=script&lang=js"
export * from "./BSInvoiceExtra.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports